import { useRouter } from "next/router";
import { useCallback, useMemo } from "react";

export const useRouteBuilder = (routeName: string): string => {
  const { buildRoute } = useBuildRouteFunction();
  const as = useMemo<string>(() => {
    return buildRoute(routeName);
  }, [routeName, buildRoute]);

  return as;
}

export const useBuildRouteFunction = (): ({ buildRoute: (routeName: string) => string }) => {
  const router = useRouter();

  const { pathPrefix, slug } = router.query;

  const params = router.asPath.split('?')[1] || '';

  const buildRoute = useCallback((routeName: string) => {
    const queryParams = params ? `?${params}` : '';
    const pathPrefixString = pathPrefix ? `/${pathPrefix}` : '';
    const slugString = slug ? `/${slug}` : '';

    return `${pathPrefixString}${slugString}/${routeName}${queryParams}`;
  }, [pathPrefix, slug, params]);

  return { buildRoute };
}